import { createUseMutation } from 'api/common/createUseMutation'
import { patchWhitelistedUsers } from 'api/fetchers/visibility/patchWhitelistedUsers'
import { queryClient } from 'app/Root'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useWhitelistUsersPatch = createUseMutation({
  fetcher: patchWhitelistedUsers,
  onSettled: async () => {
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.PREFERENCES_VISIBILITY_USERS] })
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.ME] })
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.PRACTITIONERS] })
  },
})
